import { gql } from '@apollo/client';

export const CREATE_LEAGUE_MESSAGE = gql`
  mutation CreateLeagueMessage($input: CreateLeagueMessageInput!) {
    createLeagueMessage(input: $input) {
      leagueMessage {
        id
        text
        createdAt
        user {
          id
          fullName
        }
      }
      fantasyLeagueMember {
        id
        messagesLastReadAt
        unreadMessagesCount
      }
      errors
    }
  }
`;
